import { generateColumnId } from 'modules/campaigns/modules/campaigns-reports/utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { CREATIVE_LIBRARY_REPORT_ID } from './creativeLibraryReportId';

const customColumns = {
    [REPORT_PRESET.DEFAULT]: [
        FIELDS.IS_SELECTED.field,
        FIELDS.IS_ACTIVE.field,
        FIELDS.CUSTOM_CREATIVE_NAME.field,
        FIELDS.CUSTOM_ID.field,
        FIELDS.THUMBNAIL_URL.field,
    ].map(field => generateColumnId(CREATIVE_LIBRARY_REPORT_ID, field)),
};

const defaultColumns = [
    FIELDS.IS_SELECTED.field,
    FIELDS.IS_ACTIVE.field,
    FIELDS.CUSTOM_CREATIVE_NAME.field,
    FIELDS.CUSTOM_ID.field,
    FIELDS.THUMBNAIL_URL.field,
].map(field => generateColumnId(CREATIVE_LIBRARY_REPORT_ID, field));

export { customColumns, defaultColumns };
